import { useFlags } from 'launchdarkly-react-client-sdk';

const useIsAchPrepaid = () => {
  const { billingGlobalAvailablePrepaidMethodsPermanent062321: prepaidMethods } = useFlags();
  return prepaidMethods?.split('-').includes('ach');
};

export default useIsAchPrepaid;
